import CategoryActions from "./inventory/categoryActions";
import CatalogActions from "./inventory/catalogActions";
import ImageActions from "./inventory/imageActions";
import ItemActions from "./inventory/itemActions";
import ModifierActions from "./inventory/modifierActions";
import ModifierGroupActions from "./inventory/modifierGroupActions";
import VariantActions from "./inventory/variantActions";
import ChoiceAction from "./inventory/choiceActions";
import ChoiceGroupAction from "./inventory/choiceGroupAction";
import ChoiceItemAction from "./inventory/choiceItemAction";
import InventoryEntityAction from "./inventory/inventoryEntityActions";
import SupplementAction from "./inventory/supplementActions";
import SaleAction from "./inventory/saleActions";
import BrandingActions from "./inventory/brandingActions";
import CustomItemActions from "./inventory/customItemActions";

export default {

  ...CategoryActions,
  ...CatalogActions,
  ...ImageActions,
  ...ItemActions,
  ...ModifierActions,
  ...ModifierGroupActions,
  ...VariantActions,
  ...ChoiceAction,
  ...ChoiceGroupAction,
  ...ChoiceItemAction,
  ...InventoryEntityAction,
  ...SupplementAction,
  ...SaleAction,
  ...BrandingActions,
  ...CustomItemActions
}
